import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import { useTranslation } from 'react-i18next';
import { Box, Divider, Typography } from '@mui/material';
import GridContainer from '@jumbo/components/GridContainer';
import GridItem from '@jumbo/components/GridItem';
import useImage from 'services/Hooks/useImage';
import SkeletonWrapper from 'Components/SkeletonWrapper';
import { getMerchandisingProgramItemSubLabel } from 'services/Utilities/Utilities';
import { useLanguageReference } from 'services/Hooks/useLanguageReference';
import { useMerchandisingProgramQuoteSortedSeason } from 'services/Data/MerchandisingProgramQuoteService';

const useStyles = makeStyles(theme => ({
  pageFull: {
    width: '100%',
    marginTop: '1vh',
  },
  noItem: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  center: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  totalInfo: {
    display: 'flex',
    flexDirection: 'column',
    alignContent: 'flex-end',
    alignItems: 'flex-end',
  },
  borderDanger: {
    borderColor: theme.palette.danger.main,
  },
}));

const MerchandisingProgramQuoteInfoCheckoutSection = ({ merchandisingProgramQuote, isLoading, validator, isDisabled }) => {
  const classes = useStyles();

  const { t } = useTranslation();
  const { labelReference } = useLanguageReference();

  const { getMerchandisingProgramImage } = useImage();
  const { data: sortedMerchandisingProgramSeasonEnums } = useMerchandisingProgramQuoteSortedSeason();

  return (
    <Box className={classes.pageFull}>
      {merchandisingProgramQuote &&
        merchandisingProgramQuote?.quoteItems?.map(item => (
          <GridContainer>
            <GridItem xs={12} md={2}>
              <Box className={classes.center}>
                <img
                  src={
                    item?.imgSrc
                      ? getMerchandisingProgramImage(item?.merchandisingProgram_Id, item?.imgSrc.id)
                      : '/images/brp-logo.png'
                  }
                  alt="img"
                  style={{ maxWidth: '10vh', maxHeight: '10vh' }}
                />
              </Box>
            </GridItem>
            <GridItem xs={12} md={7}>
              <Typography variant="h2">{item.name}</Typography>
              <Typography fontSize={15} color="text.secondary" sx={{ mt: 1, mb: 1 }}>
                {getMerchandisingProgramItemSubLabel(item, labelReference, sortedMerchandisingProgramSeasonEnums)}
              </Typography>
              <Divider sx={{ mt: 0, mb: item.unitPricePromotion !== item.unitPrice ? 2 : 0 }} />

              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                }}>
                <Box>
                  <Box>
                    <Typography variant="h2">{t('unitPrice')}</Typography>
                  </Box>
                </Box>
                <Box>
                  <Typography variant="h2" color={'text.primary'} fontWeight="bold">
                    ${item?.unitPrice?.toFixed(2)} {item.currencyName}
                  </Typography>
                </Box>
              </Box>
            </GridItem>
            <GridItem xs={12} md={3} sx={{ alignSelf: 'center' }}>
              <Box fontSize={20} display="flex" justifyContent={'center'} alignItems={'center'}>
                <Box>
                  <Typography variant="h2">{t('quantity')}</Typography>
                </Box>
              </Box>
              <Box display="flex" justifyContent={'center'} alignItems={'center'}>
                <Typography variant="h1">{item.quantity}</Typography>
              </Box>
            </GridItem>

            <GridItem xs={12}>
              <Divider />
            </GridItem>
          </GridContainer>
        ))}
      {!merchandisingProgramQuote ||
        (merchandisingProgramQuote.quoteItems?.lenght <= 0 && (
          <Box className={classes.noItem}>
            <Typography fontSize={20} color="text.secondary" sx={{ mt: 1, mb: 1 }}>
              {t('NoItemInMerchandisingProgramQuote')}
            </Typography>
          </Box>
        ))}
      <SkeletonWrapper
        skeletonProps={{
          width: 210,
          height: 33,
        }}
        isLoading={isLoading}
        component={
          <Box className={classes.totalInfo} sx={{ mt: 2 }}>
            <Typography variant="h1">${(merchandisingProgramQuote?.total ?? 0).toFixed(2)}</Typography>
          </Box>
        }
      />
    </Box>
  );
};

export default MerchandisingProgramQuoteInfoCheckoutSection;
